var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard"},[_c('auth-header'),_vm._v(" "),_c('div',{staticClass:"wizard__content-wrapper"},[_c('div',{staticClass:"wizard__content-cont"},[_c('router-view')],1)]),_vm._v(" "),_c('auth-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }